const _ = require('lodash')

module.exports = {
  getTagURL (tag) {
    return `/tags/${_.kebabCase(tag)}/`
  },
}
